export default "__VITE_ASSET__CVuXx2az__"